import type { ListType } from '../models/app';
import { DeliveryOrderStatus } from '../models/deliveryOrder';

export const deliveryTabRoles: string[] = [
  'admin',
  'director',
  'supervisor',
  'grocery-operator',
  'grocery-manager',
  'lossPreventionGrocery',
  'virtualAssistanceGrocery',
  'gourmet-supervisor',
  'gourmet-operator',
  'lossPreventionGourmet',
];

export const orderTabs: Record<string, string> = {
  search: 'search',
  active: 'active',
  inactive: 'inactive',
  unresolved: 'unresolved',
};

export const orderStatuses: {
  [key in 'active' | 'inactive']: Record<string, DeliveryOrderStatus>;
} = {
  active: {
    placed: DeliveryOrderStatus.Placed,
    preparing: DeliveryOrderStatus.Preparing,
    collecting: DeliveryOrderStatus.Collecting,
    transit: DeliveryOrderStatus.Transit,
    delivering: DeliveryOrderStatus.Delivering,
  },
  inactive: {
    complete: DeliveryOrderStatus.Complete,
    canceled: DeliveryOrderStatus.Canceled,
    error: DeliveryOrderStatus.Error,
  },
};

export const dropOffTypeList: ListType[] = [
  { id: 1, key: '1', label: 'Hand it to me. Do not leave unattended.' },
  { id: 2, key: '2', label: 'Please leave at door' },
];

export const gourmetEstimatePlanList: ListType[] = [
  { id: 1, key: 'basic15OpsFee5', label: 'Basic' },
  { id: 2, key: 'value30', label: 'Value' },
];

export const gourmetServiceList: ListType[] = [
  { id: 1, key: 'dd', label: 'Doordash' },
  { id: 2, key: 'ue', label: 'UberEats' },
];

export const gourmetNatureOfComplaintList: ListType[] = [
  { id: 1, key: 'Missing Item(s)', label: 'Missing Item(s)' },
  { id: 2, key: 'Wrong Item(s)', label: 'Wrong Item(s)' },
  { id: 3, key: 'Did not receive meal', label: 'Did not receive meal' },
  { id: 4, key: 'Food Quality', label: 'Food Safety' },
];

export const printMenuServiceNames = [
  {
    longName: 'ubereats',
    shortName: 'UE',
  },
  {
    longName: 'doordash',
    shortName: 'DD',
  },
  {
    longName: 'grubhub',
    shortName: 'GH',
  },
  {
    longName: 'postmates',
    shortName: 'PM',
  },
];
